module.exports = __webpack_public_path__ + "img/197.d2e524c9.jpg";